window.addEventListener( "load", function() {
    showMore();
} )

function showMore() {
    const buttons = document.querySelectorAll('.post-data .text-wrapper .more-show');

    buttons.forEach(element => {
        element.addEventListener('click', function() {
            element.classList.add("hidden");
            element.parentElement.classList.add("text-show-all");
        })
    });
}